/**
 * Android video same-frame `ended`→restart never changes presentation frame id, so VBuffer’s
 * id-change watch does not flush deferred registration schedule swaps (#1577). VideoContainer
 * notifies here; VBuffer registers a listener that calls `notifyDeferredPlaybackScheduleFrameBoundary`.
 */

let listener: (() => void) | null = null

export function setMediaLoopDeferredBoundaryListener(fn: (() => void) | null): void {
  listener = fn
}

export function notifyMediaLoopDeferredBoundary(): void {
  listener?.()
}
